import { useState, useRef, useEffect } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "Design24 cung cấp những dịch vụ gì?",
    answer:
      "Chúng tôi chuyên về Thiết kế Thương hiệu, Sản xuất TVC/Video, Phát triển Website - Ứng dụng và đào tạo tại Học viện Design24. Mỗi dịch vụ đều được xây dựng dựa trên sự sáng tạo và tính chuyên nghiệp.",
  },
  {
    question: "Thời gian thực hiện một dự án thường kéo dài bao lâu?",
    answer:
      "Tùy theo quy mô và mức độ phức tạp, một dự án có thể từ 2 đến 8 tuần. Chúng tôi luôn trao đổi rõ ràng timeline ngay từ đầu để đảm bảo tiến độ và chất lượng.",
  },
  {
    question: "Quy trình thiết kế thương hiệu của Design24 gồm những bước nào?",
    answer:
      "Chúng tôi bắt đầu từ nghiên cứu thương hiệu và khách hàng mục tiêu, sau đó xây dựng ý tưởng sáng tạo, triển khai thiết kế và cuối cùng là bàn giao giải pháp hoàn chỉnh phù hợp với chiến lược phát triển.",
  },
  {
    question: "Làm thế nào để bắt đầu hợp tác cùng Design24?",
    answer:
      "Bạn chỉ cần liên hệ qua website, email hoặc fanpage. Đội ngũ tư vấn sẽ trao đổi nhu cầu cụ thể, từ đó đề xuất giải pháp tối ưu và báo giá phù hợp.",
  },
  {
    question: "Design24 có hợp tác với startup hay chỉ thương hiệu lớn?",
    answer:
      "Chúng tôi đồng hành cùng cả startup lẫn thương hiệu đã phát triển. Với mỗi đối tác, Design24 luôn linh hoạt trong ý tưởng và giải pháp để mang lại giá trị cao nhất.",
  },
  {
    question: "Chi phí thiết kế thương hiệu hay website được tính như thế nào?",
    answer:
      "Chi phí phụ thuộc vào phạm vi và yêu cầu cụ thể của dự án. Design24 luôn minh bạch báo giá, kèm theo đề xuất các gói giải pháp phù hợp với ngân sách và mục tiêu của khách hàng.",
  },
  {
    question: "Design24 có hỗ trợ sau khi bàn giao dự án không?",
    answer:
      "Có. Chúng tôi cam kết đồng hành cùng khách hàng trong quá trình vận hành. Design24 cung cấp dịch vụ bảo trì, nâng cấp và tư vấn thêm khi thương hiệu phát triển.",
  },
  {
    question: "Đội ngũ Design24 có kinh nghiệm trong những lĩnh vực nào?",
    answer:
      "Đội ngũ chúng tôi từng tham gia nhiều dự án trong các lĩnh vực như giáo dục, công nghệ, F&B, thời trang, y tế, bất động sản và startup. Nhờ đó, mỗi giải pháp đều có tính ứng dụng cao.",
  },
  {
    question: "Học viện Design24 mang đến những khóa học gì?",
    answer:
      "Học viện Design24 tổ chức các khóa học về thiết kế đồ họa, UI/UX, thương hiệu, quay dựng video và phát triển website. Nội dung học tập thực tiễn, bám sát nhu cầu thị trường.",
  },
  {
    question: "Tại sao nên chọn Design24 thay vì đơn vị khác?",
    answer:
      "Design24 không chỉ tạo ra sản phẩm đẹp, mà còn đảm bảo hiệu quả truyền thông và tính ứng dụng thực tế. Chúng tôi kết hợp giữa sáng tạo, công nghệ và chiến lược thương hiệu để mang lại giá trị lâu dài.",
  },
];

const FAQItem = ({ faq, isActive, onClick }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (isActive) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isActive]);

  return (
    <div className={`accordion-item mb-4 ${isActive ? "show" : ""}`}>
      <h5 className="accordion-header">
        <button
          type="button"
          className={`accordion-button ${!isActive ? "collapsed" : ""}`}
          onClick={onClick}
        >
          {faq.question}
          <span className="ms-2">{isActive ? <FiMinus /> : <FiPlus />}</span>
        </button>
      </h5>
      <div
        className={`accordion-collapse ${isActive ? "show" : ""}`}
        style={{
          maxHeight: height,
          overflow: "hidden",
          transition: "max-height 0.35s ease",
        }}
      >
        <div
          ref={contentRef}
          className="accordion-body"
        >
          {faq.answer}
        </div>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section fix section-padding">
      <div className="container">
        <div className="faq-wrapper">
          <div className="row g-4">
            {/* Bên trái */}
            <div className="col-lg-6">
              <div className="faq-content-2">
                <div className="section-title">
                  <h6>Câu hỏi</h6>
                  <h2>
                    Các Câu Hỏi <br />
                    Thường Gặp <span>(FAQ)</span>
                  </h2>
                  <p className="mt-2">
                    Vẫn còn thắc mắc? Liên hệ trực tiếp với chúng tôi để được hỗ
                    trợ!
                  </p>
                </div>
                <Link
                  to="/lien-he"
                  className="theme-btn mt-3 mt-md-0"
                >
                  Liên hệ ngay
                </Link>

                <div className="faq-client-items">
                  <div className="client-info">
                    <img
                      src="assets/img/testimonial/av1.webp"
                      alt="khách hàng"
                      loading="lazy"
                    />
                    <div className="content">
                      <h4>Nguyễn Hồ Minh Quân</h4>
                      <span>An Giang</span>
                    </div>
                  </div>
                  <p>
                    Design24 đã giúp doanh nghiệp của tôi xây dựng hình ảnh
                    thương hiệu chuyên nghiệp. Sự sáng tạo trong từng chi tiết
                    khiến tôi thật sự hài lòng.
                  </p>
                </div>

                <div className="faq-client-items">
                  <div className="client-info">
                    <img
                      className=" rounded"
                      src="assets/img/testimonial/av2.webp"
                      alt="khách hàng"
                      loading="lazy"
                    />
                    <div className="content">
                      <h4>Lê Ngọc Diễm Thúy</h4>
                      <span>TP. Hồ Chí Minh</span>
                    </div>
                  </div>
                  <p>
                    Phong cách làm việc tận tâm, ý tưởng sáng tạo và kết quả
                    thiết kế vượt ngoài mong đợi. Tôi cảm nhận rõ giá trị mà
                    Design24 mang lại.
                  </p>
                </div>

                <div className="faq-client-items">
                  <div className="client-info">
                    <img
                      src="assets/img/testimonial/av1.webp"
                      alt="khách hàng"
                      loading="lazy"
                    />
                    <div className="content">
                      <h4>Phạm Hoài Phương</h4>
                      <span>TP. Cần Thơ</span>
                    </div>
                  </div>
                  <p>
                    Từ nghiên cứu thị trường đến triển khai, mọi bước đều rất
                    chuyên nghiệp. Dự án của chúng tôi nhờ vậy đã có sự khác
                    biệt rõ rệt.
                  </p>
                </div>
              </div>
            </div>

            {/* Bên phải */}
            <div className="col-lg-6">
              <div className="faq-content">
                <div
                  className="accordion"
                  id="accordion"
                >
                  {faqs.map((faq, index) => (
                    <FAQItem
                      key={index}
                      faq={faq}
                      isActive={activeIndex === index}
                      onClick={() => toggleFAQ(index)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
